import { SkyCoord } from "@stellar-globe/stellar-globe"
import { MenuItem, SubMenu } from "@szhsin/react-menu"
import { nedConeSearchUrl } from "./ned"

export function NedMenu({ openedAt }: { openedAt: SkyCoord }) {
  const openNedPage = (radiusArcmin: number) => {
    return () => {
      const { a, d } = openedAt
      window.open(nedConeSearchUrl(a.deg, d.deg, radiusArcmin), '_blank')
    }
  }

  const radiusArcminList: [number, string][] = [
    [1 / 60, '1&prime;&prime;'],
    [5 / 60, '5&prime;&prime;'],
    [1, '1&prime;'],
  ]

  return (
    <SubMenu label="Query Objects on NED within">
      <MenuItem disabled>Open NED page</MenuItem>
      {radiusArcminList.map(([radiusArcmin, label]) => (
        <MenuItem key={radiusArcmin} onClick={openNedPage(radiusArcmin)}>
          <div
            dangerouslySetInnerHTML={{ __html: label }}
          />
        </MenuItem>
      ))}
    </SubMenu>
  )
}
